/* eslint-disable react-hooks/exhaustive-deps */
import { Select } from 'antd';
import React, { useEffect, useMemo } from 'react';
import { getFilteredOptions } from '../../helper';
import { filterSelectOptions } from 'datastake-daf/src/helpers/Forms';

const CustomSelect = ({
  v = {},
  k = {},
  updateData = () => { },
  data = {},
  showIf = false,
  areYouSureState = false,
  placeholder = '',
}) => {
  const options = useMemo(() =>
    getFilteredOptions(data, v.options), [data, v]);

  useEffect(() => {
    if (data[k] && !options.find((v) => v.value === data[k])) {
      updateData(k, undefined);
    }
  }, [data, options]);

  const isDisabled = useMemo(() => {
    if (areYouSureState) {
      return true;
    }
    return v.disabled;
  }, [areYouSureState, v]);

  return (
    <div key={k}>
      <Select
        placeholder={placeholder}
        value={data[k]}
        style={{
          width: '100%',
          maxWidth: '100%',
        }}
        onChange={(e) => {
          if (typeof v?.onChangeValues === 'function') {
            return v?.onChangeValues({
              key: k,
              value: e,
              updateData,
            });
          }

          updateData(k, e);
        }}
        showSearch
        allowClear
        filterOption={filterSelectOptions}
        disabled={!showIf || isDisabled}
      >
        {options.map((o, i) => (
          <Select.Option key={`${o.value}-${i}`} value={o.value}>
            {o.label}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default CustomSelect;
